<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/parts/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";

export default {
  mixins: [UpdateForm],
  components: {App, Form},
  props: ['partId'],
  data() {
    return {
      formRoute: route('api.v1.parts.update', {part: this.partId}),
      redirectRoute: route('parts.index'),
    }
  },
  methods: {
    afterSuccess(form, response) {
      this.getPart();
    },

    getPart() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.parts.show', {part: this.partId}),
        success: (response) => {
          this.$refs.form.setPart(response.data);
        }
      }).always(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getPart();
  }
}
</script>

<template>
  <App title="Onderdeel bewerken">
    <form id="partForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="partForm"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>